import React from 'react';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { SCORING_WORKSHEET } from 'legacy-src/constants/assessmentResourceTypes';
import { getSignedS3ResourceUrl } from 'chameleon/src/utility/signedUrl';
import downloadResource from 'chameleon/legacy/src/components/pdf/PracticeExamScoringGuideButton/downloadResource';
import { associatedResourcesQuery } from 'chameleon-src/queries';
import { transformAssociatedResourcesList } from 'chameleon/ui-stack/ui/assessments/util';
import { toast } from 'chameleon/ui-stack/ui/toast';

const ScoringWorksheetAction = ({
  role,
  associatedResources,
  assessmentId,
  educationPeriod,
  client,
}) => {
  const getResource = () => {
    const resourceUrl = associatedResources[SCORING_WORKSHEET];
    const resource = resourceUrl && getSignedS3ResourceUrl(resourceUrl);
    return resource;
  };

  const fetchAssociatedResources = async () => {
    try {
      const response = await client.query({
        query: associatedResourcesQuery,
        variables: { assessmentId, educationPeriod },
      });
      return response.data.assessment.associatedResources;
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      toast(
        'An error occurred while getting the document. Please try again later.',
      );
    }
  };

  const onClick = async () => {
    const resource = getResource();
    if (resource) {
      downloadResource(resource);
    } else {
      // if we get the assessmentId and educationPeriod, we can fetch the resourceList
      const associatedResources = await fetchAssociatedResources();
      const resourceListObj =
        transformAssociatedResourcesList(associatedResources);
      const resource = getResource(resourceListObj);
      downloadResource(resource);
    }
  };
  return (
    <SingleAction
      role={role}
      onClick={onClick}
      tabIndex={0}
      isDefault={false}
      iconName="download_sheet"
      iconWidth="16"
      iconHeight="16"
      title="Scoring Worksheet"
      ariaLabel="Scoring Worksheet"
      disabled={associatedResources[SCORING_WORKSHEET] === undefined}
    >
      Scoring Worksheet
    </SingleAction>
  );
};

export default ScoringWorksheetAction;
